import mbThreeJsScene from "../Classes/mbThreeJsScene";

let hypoid3DModelShowroom;

// variables scrollhandler
let showroomTop;
let scrollPosition, windowHeight, windowWidth;
let scrollBreakpointTop, scrollBreakpointBottom;
let stylePositionAttribute;
let wayToMove, wayMoved, rotationX, rotationY, percent;
let descFirstEle, descLastEle, descMiddleEle;

let scrollTriggerStart = "top top";
let scrollTriggerEnd = "bottom top";
let showRoomReplacement = 100;

const showRoomContainer = document.getElementById(
  "mb-hypoid-showroom__wrapper"
);
const descriptionContainers = document.querySelectorAll(
  ".mb-hypoid-details__desc"
);
const showroomConnector = document.getElementById("connector-showroom");

if (descriptionContainers.length && showRoomContainer) {
  descFirstEle = descriptionContainers[0];
  descLastEle = descriptionContainers[descriptionContainers.length - 1];

  windowHeight = window.innerHeight;

  // Scroll trigger start and end for Öl-Schraube
  descMiddleEle =
    descriptionContainers[Math.floor(descriptionContainers.length / 2)];
  scrollTriggerStart =
    descMiddleEle.offsetTop - windowHeight / 2 + showRoomReplacement;
  scrollTriggerEnd =
    descLastEle.offsetTop - windowHeight / 2 + showRoomReplacement;
}

export function modelHandlerShowroom() {
  const hypoid3DModel =
    globalvars_scene["stylesheet_directory_url"] +
    "/public/models/Getriebe_retopo_anim_reverse_separated.glb";
  const canvasIdShowroom = "mb-hypoid-showroom";
  const canvasShowroom = document.getElementById(canvasIdShowroom);

  if (!canvasShowroom) return;

  const argsModelShowRoom = {
    cameraPerspective: {
      fov: 35,
      ascpect: canvasShowroom.offsetWidth / canvasShowroom.offsetHeight,
      near: 0.1,
      far: 500,
    },
    cameraPosition: {
      x: 0,
      y: 0.05,
      z: 0.3,
    },
    rotation: {
      x: -10,
      y: -30,
      z: 0,
    },
    scale: {
      x: 0.15,
      y: 0.15,
      z: 0.15,
    },
    scrollTrigger: {
      start: scrollTriggerStart,
      end: scrollTriggerEnd,
    },
    animateInstantClips: [0, 1],
    animateOnScrollClips: [3],
  };

  let modelLoadEvent = function ($that) {
    // try to fix collor issue of rotating arrows
    let modelScene = $that.modelScene;
    let pfeil = modelScene.children[0].children[0].children[1];

    pfeil.material.metalness = 1;

    // showroomOnWindowScroll();
  };

  hypoid3DModelShowroom = new mbThreeJsScene(
    canvasIdShowroom,
    hypoid3DModel,
    argsModelShowRoom,
    modelLoadEvent
  );

  // ================================================== eventlistener
  showroomOnWindowScroll();
  // jQuery(document).ready(showroomOnWindowScroll);

  window.addEventListener("scroll", showroomOnWindowScroll, false);
  window.addEventListener("resize", showroomOnWindowScroll, false);
}

/**
 * On scroll
 */
function showroomOnWindowScroll() {
  if (!descFirstEle || !descLastEle) return;

  showRoomReplacement = 100; // position correction

  // setup variables
  scrollPosition = window.pageYOffset;
  windowHeight = window.innerHeight;
  windowWidth = window.innerWidth;

  if (windowWidth >= 960) {
    // desktop
    scrollBreakpointTop =
      descFirstEle.offsetTop - windowHeight / 2 + showRoomReplacement;
    scrollBreakpointBottom =
      descLastEle.offsetTop - windowHeight / 2 + showRoomReplacement;
  } else {
    // mobile
    scrollBreakpointTop = descFirstEle.offsetTop - windowHeight / 2;
    scrollBreakpointBottom = descLastEle.offsetTop - windowHeight / 2;
  }

  // check viewport position
  if (scrollPosition <= scrollBreakpointTop) {
    showroomTop = scrollBreakpointTop;
    stylePositionAttribute = "absolute";
  } else if (
    scrollPosition > scrollBreakpointTop &&
    scrollPosition < scrollBreakpointBottom
  ) {
    showroomTop = 0;
    stylePositionAttribute = "fixed";

    wayToMove = scrollBreakpointBottom - scrollBreakpointTop;
    wayMoved = scrollPosition - scrollBreakpointTop;

    percent = ((100 / wayToMove) * wayMoved) / 100;

    rotationX = -10 + 30 * percent;
    rotationY = -30 + 60 * percent;

    hypoid3DModelShowroom.setRotation(rotationX, "x");
    hypoid3DModelShowroom.setRotation(rotationY, "y");
  } else {
    showroomTop = scrollBreakpointBottom;
    stylePositionAttribute = "absolute";
  }

  // show / hide connector
  if (
    scrollPosition < scrollBreakpointTop + 120 ||
    scrollPosition > scrollBreakpointBottom - 120
  ) {
    jQuery(showroomConnector).fadeOut(100);
  } else {
    jQuery(showroomConnector).fadeIn(100);
  }

  // update showroom
  showRoomContainer.style.cssText =
    "top:" + showroomTop + "px; position:" + stylePositionAttribute;
}
